module.exports = __webpack_public_path__ + "static/media/money3.1d26e667.jpg";